import React from "react";

import DialogConfig from "./DialogConfig.interface";

const DialogContext = React.createContext<
  ((config: DialogConfig) => void) | null
>(null);
export default DialogContext;
